// extracted by mini-css-extract-plugin
export default {"container":"dash-icon_style_container__Dsa-3","dashIcon":"dash-icon_style_dashIcon__1y8ye"};